<ng-template class="rights" #template>
    <div class="right-description-popup">
        <generic-list-manager [config]="tableConfig"></generic-list-manager>
    </div>
</ng-template>
